const menus = [
  {
    title: "Topics",
    sections: [
      {
        heading: "Topics",
        slug: "/tags/PXovYV/topics",
        testID: "navListTopics",
        tags: [
          {
            name: "Travel & Adventure",
            description:
              "Explore new places and boldly venture into the unknown!",
            slug: "/tags/eYx6D2/adventure-awaits",
          },
          {
            name: "Food & Cooking",
            description:
              "Develop a flair for flavor, and share your love of cooking and baking",
            slug: "/tags/eYRMnw/chowtown",
          },
          {
            name: "Mindfulness & Mental Health",
            description:
              "Tune into your body, your surroundings, and focus on your mental health",
            slug: "/tags/PXodv2/flow-and-steady",
          },
          {
            name: "Music & Dance",
            description:
              "Make beautiful noise, listen, move and groove to the beat",
            slug: "/tags/lYOQA2/pop-n-bop",
          },
          {
            name: "Outdoors & the Environment",
            description:
              "Discover the joy of being outdoors, and work to protect our natural world",
            slug: "/tags/NXQ0WY/the-great-outdoors",
          },
        ],
      },
    ],
  },
  {
    title: "Channels",
    sections: [
      {
        heading: "Channels",
        slug: "/tags/6YlOrw/channels",
        testID: "navListChannels",
        tags: [
          {
            name: "The Best Tees",
            description:
              "Sing, dance, and be your BEST SELF with this dynamic duo!",
            img:
              "https://cdn.gonoodle.com/Universe-Component-Library/navigation/BT_PROD_Channel+Icon.png",
            slug: "/tags/DYL8qY/the-best-tees",
          },
          {
            name: "Blazer Fresh",
            description:
              "Get down, get funky & get schooled with this edutaining hip hop trio!",
            img:
              "https://cdn.gonoodle.com/Universe-Component-Library/navigation/BF_PROD_Channel+Icon.png",
            slug: "/tags/AYKMb2/blazer-fresh",
          },
          {
            name: "The Champiverse",
            description:
              "Get amped as you sing, dance and stamp with all the champs!",
            img:
              "https://cdn.gonoodle.com/Universe-Component-Library/navigation/CHA_PROD_Channel+Icon.png",
            slug: "/tags/yweK9X/the-champiverse",
          },
          {
            name: "Moose Tube",
            description: "Sing and move with a-moose-ing chants and cheers.",
            img:
              "https://cdn.gonoodle.com/Universe-Component-Library/navigation/MT_PROD_Channel+Icon.png",
            slug: "/tags/WwJQ12/moose-tube",
          },
          {
            name: "Vamos GoNoodle",
            description: "Move, baila y canta con ¡Vamos! GoNoodle",
            img:
              "https://cdn.gonoodle.com/Universe-Component-Library/navigation/VAMOS_PROD_Channel+Icon.png",
            slug: "/tags/W2gjaX/vamos-gonoodle",
          },
        ],
      },
    ],
  },
  {
    title: "Activities & Routines",
    sections: [
      {
        heading: "Activity Type",
        slug: "/tags/QXBVXl/activity-type",
        testID: "navListActivityType",
        tags: [
          {
            name: "Breathe",
            description: "",
            slug: "/tags/ZwmOzX/breathe",
          },
          {
            name: "Guided Dance",
            description: "",
            slug: "/tags/0YZ0G2/guided-dance",
          },
          {
            name: "How-To",
            description: "",
            slug: "/tags/7Yjqnw/how-to",
          },

          {
            name: "Stretch",
            description: "",
            slug: "/tags/6Yl682/stretch",
          },
          {
            name: "Workout",
            description: "",
            slug: "/tags/xX0LZX/workout",
          },
        ],
      },
      {
        heading: "Routines",
        slug: "/tags/r26b2L/routines",
        testID: "navListRoutines",
        tags: [
          {
            name: "Class Routines",
            description: "",
            slug: "/tags/xX0ZwZ/class-routines",
          },
          {
            name: "Indoor Recess",
            description: "",
            slug: "/tags/7YjnY3/indoor-recess",
          },
          {
            name: "Test Best",
            description: "",
            slug: "/tags/aYyW26/test-best",
          },
          {
            name: "Wake Up",
            description: "",
            slug: "/tags/9Y7928/wake-up",
          },
          {
            name: "Bedtime",
            description: "",
            slug: "/tags/eXAmX8/bedtime",
          },
        ],
      },
      {
        heading: "Holidays & Events",
        slug: "/tags/lYOA2a/holidays-and-events",
        testID: "navListHolidays",
        tags: [
          {
            name: "Summertime",
            description: "",
            slug: "/tags/72GmzY/summertime",
          },
          {
            name: "Birthday",
            description: "",
            slug: "/tags/eXdM23/birthdays",
          },
          {
            name: "Back To School",
            description: "",
            slug: "/tags/lYVLL2/back-to-school",
          },
        ],
      },
    ],
  },
  {
    title: "Skills & Knowledge",
    sections: [
      {
        heading: "Curriculum",
        slug: "/tags/lYVL2g/curriculum",
        testID: "navListCurriculum",
        tags: [
          {
            name: "English Language Arts",
            description: "",
            slug: "/tags/eYRnYK/english-language-arts",
          },
          {
            name: "Math",
            description: "",
            slug: "/tags/NXQWwn/math",
          },
          {
            name: "Reading Practice",
            description: "",
            slug: "/tags/ywe7XK/reading-practice",
          },

          {
            name: "Science",
            description: "",
            slug: "/tags/EY9ZXb/science",
          },
          {
            name: "Social Studies",
            description: "",
            slug: "/tags/DYLowW/social-studies",
          },
        ],
      },
      {
        heading: "Grades",
        slug: "/tags/eYxDYg/grades",
        testID: "navListGrades",
        tags: [
          {
            name: "Pre-K",
            description: "",
            slug: "/tags/aYyOW2/pre-k",
          },
          {
            name: "Kindergarten",
            description: "",
            slug: "/tags/GYpvD2/kindergarten",
          },
          {
            name: "1st Grade",
            description: "",
            slug: "/tags/9Y7l9X/1st-grade",
          },
          {
            name: "2nd Grade",
            description: "",
            slug: "/tags/rwqW5X/2nd-grade",
          },
          {
            name: "3rd Grade",
            description: "",
            slug: "/tags/zXNzWX/3rd-grade",
          },
        ],
      },
      {
        heading: "Sensory & Motor Skills",
        slug: "/tags/72GzXe/sensory-and-motor-skills",
        testID: "navListMotorSkills",
        tags: [
          {
            name: "Body Awareness",
            description: "",
            slug: "/tags/W2gQYz/body-awareness",
          },
          {
            name: "Coordination",
            description: "",
            slug: "/tags/L2nyXW/coordination",
          },
          {
            name: "Cross Lateral Skills",
            description: "",
            slug: "/tags/QXPOYz/cross-lateral-skills",
          },
          {
            name: "Gross Motor Skills",
            description: "",
            slug: "/tags/PY15Yl/gross-motor-skills",
          },
          {
            name: "Locomotor Skills",
            description: "",
            slug: "/tags/6Yl8Yk/locomotor-skills",
          },
        ],
      },
    ],
  },
];

const compactMenu = [
  {
    name: "Search",
    slug: "/search",
  },
  {
    name: "Topics",
    slug: "/tags/PXovYV/topics",
  },
  {
    name: "Channels",
    slug: "/tags/6YlOrw/channels",
  },
  {
    name: "Activity Type",
    slug: "/tags/QXBVXl/activity-type",
  },
  {
    name: "Routines",
    slug: "/tags/r26b2L/routines",
  },
  {
    name: "Holidays & Events",
    slug: "/tags/lYOA2a/holidays-and-events",
  },
  {
    name: "Curriculum",
    slug: "/tags/lYVL2g/curriculum",
  },
  {
    name: "Grades",
    slug: "/tags/eYxDYg/grades",
  },
  {
    name: "Sensory & Motor Skills",
    slug: "/tags/72GzXe/sensory-and-motor-skills",
  },
];

export { menus, compactMenu };
